import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const CopySvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.75 4.5V3.25C4.75 2.55964 5.30964 2 6 2H10.75C11.4404 2 12 2.55964 12 3.25V8C12 8.69036 11.4404 9.25 10.75 9.25H9.5M3.25 4.75H8C8.69036 4.75 9.25 5.30964 9.25 6V10.75C9.25 11.4404 8.69036 12 8 12H3.25C2.55964 12 2 11.4404 2 10.75V6C2 5.30964 2.55964 4.75 3.25 4.75Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default CopySvg
